import Vue from 'vue'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import '@core/scss/vue/libs/vue-wizard.scss'
import '@core/assets/fonts/feather/iconfont.css'

Vue.use(VueFormWizard)